<glxy-page [isLoading]="isLoading" [pagePadding]="true">
  <glxy-page-toolbar *ngIf="viewConfig?.showTitle || viewConfig?.showCloseButton" [extendedToolbarPadding]="false">
    <glxy-page-title *ngIf="viewConfig?.showTitle">{{ 'COMMENT.TITLE' | translate }}</glxy-page-title>

    <glxy-page-actions *ngIf="viewConfig?.showCloseButton">
      <mat-icon class="action-close" (click)="handleCloseClick()">close</mat-icon>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper [widthPreset]="pageWidth">
    <div class="project-comments-container">
      <ng-container *ngIf="viewConfig?.showCommentInputAtTop">
        <ng-container *ngTemplateOutlet="commentInput"></ng-container>
      </ng-container>
      <glxy-comment
        *ngFor="let conversation of conversation$$ | async"
        [messageFrom]="this.getConversationOrigin(conversation)"
        [messageText]="conversation?.messageText?.trim()"
        [messageMetadata]="conversation.messageCreated | date : 'MMM d, y h:mm a'"
        [profilePicUrl]="conversation?.senderImageUrl"
        [class.private]="conversation?.commentType === commentType.COMMENT_TYPE_PRIVATE"
      >
        <div *ngIf="conversation?.taskTitle" class="visible-container">
          {{ 'COMMENT.FROM_STEP' | translate }} {{ conversation?.taskTitle }}
        </div>
        <div *ngIf="conversation?.commentType === commentType.COMMENT_TYPE_PRIVATE" class="visible-container">
          <mat-icon>visibility</mat-icon>
          <span>{{ 'TASK_DETAILS.PRIVATE_CONVERSATION_SUBTEXT' | translate }}</span>
        </div>
      </glxy-comment>
      <ng-container *ngIf="!viewConfig?.showCommentInputAtTop">
        <ng-container *ngTemplateOutlet="commentInput"></ng-container>
      </ng-container>
    </div>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #loadingSpinner>
  <mat-spinner [diameter]="36"></mat-spinner>
</ng-template>

<ng-template #commentInput>
  <div class="new-comment-container">
    <ng-container *ngIf="activeUser && viewConfig?.showCommenterIcon" class="new-comment-icon">
      <div *ngIf="activeUser.profilePictureUrl || activeUser.userInfo" class="new-comment-icon">
        <glxy-avatar
          class="card-image"
          [icon]="activeUser.profilePictureUrl"
          [name]="activeUser.userInfo?.firstName | nameInitials"
          [width]="40"
        ></glxy-avatar>
      </div>
    </ng-container>
    <ng-container *ngIf="!hasCustomInput">
      <mat-form-field appearance="outline" class="new-comment-input">
        <mat-label>{{ 'COMMENT.NEW_COMMENT.LABEL' | translate }}</mat-label>
        <input matInput [formControl]="newCommentInput" />
      </mat-form-field>
    </ng-container>
    <ng-content select="project-comments-input"></ng-content>
  </div>
  <div class="input-actions-container">
    <mat-checkbox
      class="visibility-toggle"
      *ngIf="!disablePrivate"
      [checked]="isPublic"
      (change)="toggleIsPublic()"
      color="primary"
    >
      {{ 'COMMENT.NEW_COMMENT.MAKE_PUBLIC' | translate }}
    </mat-checkbox>
    <button
      *ngIf="!isSubmitting; else loadingSpinner"
      mat-flat-button
      color="primary"
      [disabled]="shouldDisableSubmit"
      (click)="handleSubmitClick()"
    >
      {{ 'COMMENT.NEW_COMMENT.ACTION' | translate }}
    </button>
  </div>
  <mat-divider *ngIf="viewConfig.showCommentInputAtTop"></mat-divider>
</ng-template>
